import EpisodeCard from './EpisodeCard';

export default EpisodeCard;
